import type { CustomerNoteAttachment } from "../../api/queries/customerOrganizationQueries";

export function isAcceptedCustomerNoteFile(file: File): boolean {
  const mime = file.type.toLowerCase();
  if (mime.startsWith("image/")) return true;
  if (mime === "application/pdf") return true;
  return file.name.toLowerCase().endsWith(".pdf");
}

export function isPreviewableCustomerNoteAttachment(
  attachment: CustomerNoteAttachment,
): boolean {
  const mime = attachment.content_type?.toLowerCase() ?? "";
  if (mime.startsWith("image/")) return true;
  if (mime === "application/pdf") return true;
  return attachment.filename.toLowerCase().endsWith(".pdf");
}
